export default {
  name: 'myMenuTitle',
  props: {
    title: {
      type: String
    }
  }
};